import grapesjs from 'drapcode-builder';
import loadComponents from './components';

export default grapesjs.plugins.add('plaid', (editor, opts = {}) => {
  const default_types = {
    plaidButton: 'plaid',
  };
  const default_labels = {
    plaidButton: 'Plaid',
  };
  const options = {
    ...{
      labels: default_labels,
      types: default_types,
      labelShoppingCartCategory: 'Payment Gateway',
    },
    ...opts,
  };

  loadComponents(editor, options);
});
